var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/components/translate-button.tsx";
import "core-js/modules/es.array.includes.js";
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { translateStatus, undoStatusTranslation } from 'soapbox/actions/statuses';
import { useAppDispatch, useAppSelector, useFeatures } from 'soapbox/hooks';
import { Stack } from './ui';

const TranslateButton = _ref => {
  let {
    status
  } = _ref;
  const dispatch = useAppDispatch();
  const intl = useIntl();
  const features = useFeatures();
  const me = useAppSelector(state => state.me);
  const renderTranslate = me && ['public', 'unlisted'].includes(status.visibility) && status.contentHtml.length > 0 && status.language !== null && intl.locale !== status.language;

  const handleTranslate = e => {
    e.stopPropagation();

    if (status.translation) {
      dispatch(undoStatusTranslation(status.id));
    } else {
      dispatch(translateStatus(status.id, intl.locale));
    }
  };

  if (!features.translations || !renderTranslate) return null;

  if (status.translation) {
    const languageNames = new Intl.DisplayNames([intl.locale], {
      type: 'language'
    });
    const languageName = languageNames.of(status.language);
    const provider = status.translation.get('provider');
    return /*#__PURE__*/React.createElement(Stack, {
      className: "text-gray-700 dark:text-gray-600 text-sm",
      alignItems: "start",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 42,
        columnNumber: 7
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "status.translated_from_with",
      defaultMessage: "Translated from {lang} using {provider}",
      values: {
        lang: languageName,
        provider
      },
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 43,
        columnNumber: 9
      }
    }), /*#__PURE__*/React.createElement("button", {
      className: "text-primary-600 dark:text-accent-blue hover:text-primary-700 dark:hover:text-accent-blue hover:underline",
      onClick: handleTranslate,
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 45,
        columnNumber: 9
      }
    }, /*#__PURE__*/React.createElement(FormattedMessage, {
      id: "status.show_original",
      defaultMessage: "Show original",
      __self: this,
      __source: {
        fileName: _jsxFileName,
        lineNumber: 46,
        columnNumber: 11
      }
    })));
  }

  return /*#__PURE__*/React.createElement("button", {
    className: "text-primary-600 dark:text-accent-blue hover:text-primary-700 dark:hover:text-accent-blue text-left text-sm hover:underline",
    onClick: handleTranslate,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 53,
      columnNumber: 5
    }
  }, /*#__PURE__*/React.createElement(FormattedMessage, {
    id: "status.translate",
    defaultMessage: "Translate",
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 54,
      columnNumber: 7
    }
  }));
};

export default TranslateButton;